import {
  RotateLeftOutlined,
  RotateRightOutlined,
  SwapOutlined,
  ZoomInOutlined,
  ZoomOutOutlined
} from '@ant-design/icons';
import { useQuery } from '@tanstack/react-query';
import { Image, Space } from 'antd';
import { useEffect, useState } from 'react';
import { getTransportationTicketFile } from 'src/apis/hr_ticket/transportationTicket.api';
import { ITransportationAttachFile } from 'src/types/hr_ticket/transportationTicket.type';
import { getFilePreview, isImage } from 'src/utils/utils';

interface Props {
  ticketAttachment: ITransportationAttachFile;
  size?: number;
  className?: string;
}

const TransportationAttachmentImage = ({ ticketAttachment, size, className }: Props) => {
  const [src, setSrc] = useState<string>();
  const isImg = isImage(ticketAttachment.name || ticketAttachment.originalName || '');

  const ticketAttachmentQuery = useQuery({
    queryKey: ['transportationAttachmentImage', ticketAttachment.id],
    queryFn: () => getTransportationTicketFile(ticketAttachment)
  });

  useEffect(() => {
    if (ticketAttachmentQuery.data?.data) {
      if (isImg) {
        const url = URL.createObjectURL(new Blob([ticketAttachmentQuery.data?.data]));
        setSrc(url);
      } else {
        setSrc(getFilePreview(ticketAttachment.name || ticketAttachment.originalName || ''));
      }
    }
  }, [ticketAttachmentQuery.data?.data, isImg, ticketAttachment.name, ticketAttachment.originalName]);

  const handleOpenNonImage = () => {
    if (ticketAttachmentQuery.data?.data) {
      const blob = new Blob([ticketAttachmentQuery.data?.data], {
        type: ticketAttachment.contentType || ticketAttachment.fileType || 'application/octet-stream'
      });
      const url = URL.createObjectURL(blob);
      window.open(url, '_blank');
    }
  };

  if (!isImg) {
    return (
      <button
        type='button'
        className={className}
        style={{
          width: size ?? 100,
          height: size ?? 100,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          cursor: 'pointer',
          border: '1px solid #d9d9d9',
          borderRadius: '8px',
          overflow: 'hidden',
          backgroundColor: '#fafafa',
          padding: 0
        }}
        onClick={handleOpenNonImage}
      >
        <img src={src} alt={ticketAttachment.name} style={{ width: '50%', height: '50%', objectFit: 'contain' }} />
      </button>
    );
  }

  return (
    <Image
      key={ticketAttachment.id}
      width={size ?? 100}
      height={size ?? 100}
      loading={'lazy'}
      src={src}
      className={className}
      preview={{
        toolbarRender: (
          _,
          { transform: { scale }, actions: { onFlipY, onFlipX, onRotateLeft, onRotateRight, onZoomOut, onZoomIn } }
        ) => (
          <Space size={12} className='toolbar-wrapper'>
            <SwapOutlined rotate={90} onClick={onFlipY} />
            <SwapOutlined onClick={onFlipX} />
            <RotateLeftOutlined onClick={onRotateLeft} />
            <RotateRightOutlined onClick={onRotateRight} />
            <ZoomOutOutlined disabled={scale === 1} onClick={onZoomOut} />
            <ZoomInOutlined disabled={scale === 50} onClick={onZoomIn} />
          </Space>
        )
      }}
    />
  );
};

export default TransportationAttachmentImage;
